import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../../../shared/api/axios-instance';
import { PlatformDto } from '../../../../shared/dtos/platform.dto';
import { PlatformModel } from '../../../../shared/models/platform.model';
import { mapPlatformDtoToPlatformModel } from '../../../../shared/utils/mapping/mapping.utils';

export const getApkPlatforms: AsyncThunk<
  PlatformModel[],
  void,
  Record<string, unknown>
> = createAsyncThunk('get-apk-platforms', async () => {
  const { data }: AxiosResponse<PlatformDto[]> = await axiosInstance.get(
    '/platforms'
  );
  return data.map(mapPlatformDtoToPlatformModel);
});
